<div class="w-full space-y-10" *transloco="let t">
  <h1 class="text-3xl font-semibold">
    {{
      t('portal.courses.dashboard.welcome.greeting', {
        name: (userDetails$ | async)?.username?.split(' ')?.[0] || '',
      })
    }}
  </h1>

  @if (
    !learningPlans() || learningPlans()!.learningPlanInstances.length === 0
  ) {
    <div
      class="flex max-w-[1150px] flex-col items-center justify-between gap-4 rounded-2xl bg-grey-lightGrey p-10 md:flex-row"
    >
      <div class="max-w-md space-y-6 py-12">
        <h2
          class="text-2xl font-semibold"
          [innerHTML]="t('portal.courses.dashboard.welcome.chooseTraining')"
        ></h2>

        <button
          (click)="navigateToCourseLibrary()"
          class="inline-flex items-center justify-center rounded-lg bg-blue px-4 py-2.5 text-sm font-medium text-white transition hover:bg-blue-hover"
        >
          {{ t('portal.courses.dashboard.welcome.discoverLibrary') }}
        </button>
      </div>

      <div class="w-full md:w-auto">
        <img
          [src]="dashboardImageSrc$ | async"
          alt="Dashboard Welcome"
          class="w-full max-w-md cursor-pointer rounded-xl"
          tabindex="0"
          (click)="navigateToCourseLibrary()"
          (keyup.enter)="navigateToCourseLibrary()"
          (keyup.space)="navigateToCourseLibrary()"
        />
      </div>
    </div>
  }

  <section class="space-y-4">
    <div class="flex justify-between">
      <h3 class="text-xl font-semibold">
        {{ t('portal.courses.dashboard.welcome.activeTrainings') }}
      </h3>
      @if (
        subscription()?.isBoundToLearningPlans &&
        learningPlans() &&
        learningPlans()!.learningPlanInstances.length > 0
      ) {
        <app-primary-button
          [text]="t('portal.courses.dashboard.courseLibraryButton')"
          (buttonClicked)="navigateToCourseLibrary()"
        />
      }
    </div>

    @if (
      !learningPlans() || learningPlans()!.learningPlanInstances.length === 0
    ) {
      <p class="max-w-[1150px] text-center text-sm text-grey">
        {{ t('portal.courses.dashboard.welcome.emptyDashboard') }}
      </p>
    } @else {
      @if (subscription()?.isBoundToLearningPlans) {
        <app-learning-plan-course-instance-overview />
      } @else {
        <app-course-instances-overview />
      }
    }
  </section>
</div>
